import { Pipe, PipeTransform } from '@angular/core'

/**
 * @description Masks/pads a number with a dots. Useful for masking sensitive
 * information such as phone numbers and credit card numbers.
 * @param maskedAmount The amount of masking dots to prepend to the value (Default = 3)
 * @param sliceSize The amount of characters to display from the end of the value (Default = 3)
 * @example `{{ profile.phone_number | gbNumberMask: 4:4 }}`
 */
@Pipe({
  name: 'gbNumberMask',
})
export class GbNumberMaskPipe implements PipeTransform {
  transform(value?: string | number, maskedAmount: number = 3, sliceSize: number = 3) {
    if (!value && value !== 0) {
      return value
    }

    const dotCharacter = '• '
    const valSectionShowing = String(value).slice(-sliceSize)

    let result = dotCharacter.repeat(maskedAmount)
    result += valSectionShowing

    return result
  }
}
